<template>
  <v-stepper v-model="step" class="password-stepper">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1" color="teal-lighten-1">
        Step-1
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step > 2" step="2" color="teal-lighten-1">
        Step-2
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="3" color="#708AA7"> Confirm OTP </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="deposit-form create-account-form" :class="$vuetify.theme.dark ? 'transparent' : 'transparent'">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Withdraw Amount</legend>
                <v-text-field v-model="amount" label="Enter Your Amount" :placeholder="`Remaining Balance: ${this.user_ib_balance} USD`" single-line solo hide-details
                  class="custom-select" type="number"></v-text-field>
                <p v-if="errorMessage !== null" class="error-text mt-4">
                  *{{ errorMessage }}
                </p>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Bank Name</legend>
                <v-text-field v-model="bank_name" label="Write Bank Name" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset>
            </v-col>
            <!-- <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Bank Country</legend>
                <v-text-field v-model="bank_country" label="Write Country Name" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset>
            </v-col> -->
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Bank Account Name</legend>
                <v-text-field v-model="bank_account_name" label="Write Account Name" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-btn class="text-capitalize btn-account" color="teal-lighten-1" tile elevation="0"
                @click="updateStep(2)">
                Next Step
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>

      <!-- Step 2 Content -->
      <v-stepper-content step="2">
        <v-card class="deposit-form create-account-form" color="transparent">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>IBAN Number</legend>
                <v-text-field type="number" v-model="bank_iban" label="Enter Your Name" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Bank Swift Code</legend>
                <v-text-field v-model="bank_swift" label="Write Bank Name" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset>
            </v-col>
            <!-- <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Bank Address</legend>
                <v-text-field v-model="bank_address" label="Write Country Name" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset>
            </v-col> -->
            <v-col cols="12" sm="12" md="12">
              <v-btn :loading="isLoading" :disabled="isLoading" class="text-capitalize btn-account" color="teal-lighten-1" tile elevation="0" @click="sendOtp">
                Next Step
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>

      <!-- Step 3 Content -->
      <v-stepper-content step="3">
        <v-card class="deposit-form password-field create-account-form" color="transparent">
          <v-row>
            <v-col>
              <p>
                An OTP has been sent to
                <span class="text--green">{{ profile?.email }}</span>
              </p>
              <fieldset>
                <legend>Enter OTP</legend>
                <v-text-field label="**************" v-model="verification_code" single-line solo hide-details
                  class="custom-select" type="number"></v-text-field>
              </fieldset>
              <v-card-actions class="pa-0">
                <v-btn :loading="isLoading" :disabled="isLoading" class="ma-0 text-capitalize btn-account w-100" color="teal-lighten-1" tile elevation="0"
                  @click="verifyOtp">
                  Confirm
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import toast from "@/services/Notification";
import {
  PROFILE__ACTIONS,
  TRADINGACCOUNTSTOTRANSFER__ACTIONS,
} from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      show1: false,
      verification_code: null,
      amount: null,
      bank_name: null,
      isLoading: false,
      // bank_country: null,
      bank_account_name: null,
      bank_iban: null,
      bank_swift: null,
      // bank_address: null,
    };
  },
  computed: {
    ...mapState("profile", ["profile"]),
    ...mapState("tradingaccounts", ["step", "errorMessage", "user_ib_balance"]),
  },

  methods: {
    ...mapActions("profile", [PROFILE__ACTIONS.PROFILE]),
    ...mapActions("tradingaccounts", [
      TRADINGACCOUNTSTOTRANSFER__ACTIONS.BANKTRANSFERSENDOTP,
      TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMBANKTRANSFER,
      TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER,
    ]),

    updateStep(step) {
      if (step === 2) {
        if (this.amount === null) {
          toast.error("Amount field is required");
        } else if (this.bank_name === null) {
          toast.error("Bank Name field is required");
        // } else if (this.bank_country === null) {
        //   toast.error("Bank Country field is required");
        } else if (this.bank_account_name === null) {
          toast.error("Bank Account Name field is required");
        } else {
          this.$store.commit("tradingaccounts/SET_STEP", step);
        }
      } else {
        this.$store.commit("tradingaccounts/SET_STEP", step);
      }
    },

    async sendOtp() {
      try {
      if (this.amount === null) {
        toast.error("Amount field is required");
      } else if (this.user_ib_balance < this.amount) {
        toast.error(`Insufficient Balance!, Remaining Balance: ${this.user_ib_balance} USD`);
      } else if (this.bank_name === null) {
        toast.error("Bank Name field is required");
        // } else if (this.bank_country === null) {
          //   toast.error("Bank Country field is required");
        } else if (this.bank_account_name === null) {
          toast.error("Bank Account Name field is required");
        } else if (this.bank_iban === null) {
          toast.error("Bank IBN field is required");
        } else if (this.bank_swift === null) {
          toast.error("Bank Swift field is required");
          // } else if (this.bank_address === null) {
            //   toast.error("Bank Address field is required");
        } else {
          this.isLoading = true;
          await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.BANKTRANSFERSENDOTP]({
            amount: this.amount,
            bank_name: this.bank_name,
            // bank_country: this.bank_country,
            bank_account_name: this.bank_account_name,
            bank_iban: this.bank_iban,
            bank_swift: this.bank_swift,
            // bank_address: this.bank_address,
          });
        }
      } catch (error) {
        // console.error("Error in sendOtp:", error);
        toast.error("Failed to send OTP. Please try again.");
      } finally {
        this.isLoading = false;
      }
    },

    async verifyOtp() {
      try {
        if (!this.verification_code) {
          toast.error("Please type a verification code.");
        } else {
          this.isLoading = true;
          await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMBANKTRANSFER]({
            verification_code: this.verification_code,
          });
          this.bank_name = null;
          this.amount = null;
          this.bank_account_name = null;
          // this.bank_country = null;
          this.bank_iban = null;
          this.bank_swift = null;
          // this.bank_address = null;
          this.verification_code = null;
        }
      } catch (error) {
        // console.error("Error in verifyOtp:", error);
        toast.error("Failed to verify OTP. Please try again.");
      } finally {
        this.isLoading = false;
      }
    },
  },

  async mounted() {
    this.$router.push({ query: {} });
    await this[PROFILE__ACTIONS.PROFILE]();
    await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER]();
  },
};
</script>
